/**
 * Created by amirb on 5/19/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var Bubble = require("ui/bubble/Bubble");
    var ChatLineStateBubbleView = require("web-agent-views/ChatLineStateBubbleView");
    var ViewController = require('web-agent-framework/ViewController');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var STRUCTURE_CONTENT_FAILED_STATUS = 'STRUCTURE_CONTENT_FAILED';

    var ChatLineStateViewController = ViewController.extend({
        ControllerName:'ChatLineStateViewController',
        LPViewMap:{
            lpview_state_icon: ".lpview_state_icon"
        },
        LPClassesMap: {
            state_icon: "lpview_state_icon",
            line_state_icon: "line_state_icon",
            READ: 'read',
            SENT: 'sent',
            ACCEPT: 'accept',
            VIEWED: 'viewed',
            ERROR: 'error',
            NACK: 'nack',
            STRUCTURE_CONTENT_FAILED: 'failed'
        },
        initialize:function (constructorData) {
            this.currentView = constructorData.lineView;
            this.squenceId = constructorData.squenceId;
            this.convId = constructorData.convId;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.modelController = constructorData.modelController;
            this.rowData = constructorData.data;

            this.chatLineStateTextMap = {};
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.READ] = this.translate("MESSAGE_READ");
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.ACCEPT] = this.translate("MESSAGE_RECEIVED");
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.SENT] = this.translate("MESSAGE_SENT");
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.VIEWED] = this.translate("secure_form_viewed_event_text_generic");
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.ERROR] = this.translate("secure_form_error_event_text_generic");
            this.chatLineStateTextMap[lpTag.AMSStatics.messageState.NACK] = this.translate("MESSAGE_NACK");
            this.chatLineStateTextMap[STRUCTURE_CONTENT_FAILED_STATUS] = this.translate("structure_content_message_failed");

            this.consumerId = this.modelController.getModelParam('chats.' + this.convId +'.visitorInfo.visitorId');
            this.agentId = this.modelController.getModelParam('agent.messagingUserId');

            if(this.rowData.isHistory && this.rowData.source !== 'visitor') {
                var status = this.rowData.status || lpTag.AMSStatics.messageState.SENT;
                updateLineState.call(this, status);
            }
        },

        events:function () {
            if(this.rowData.originatorId !== this.consumerId && !this.rowData.isHistory){
                this.bindModel({modelPath : 'chats.' + this.convId + '.chatInfo.linesState', callback : this.bindToChatInfo, context:this});
            }
        },

        render:function () {
        }
    });

    ChatLineStateViewController.prototype.bindToChatInfo = function(){
        if(this && this.disposed) {return;}
        if(typeof this.rowData.sequenceId !== 'undefined'){
            this.unbindModel({modelPath : 'chats.' + this.convId + '.chatInfo.linesState', callback : this.bindToChatInfo, context:this});
            this.bindModel({modelPath : 'chats.' + this.convId + '.chatInfo.linesState.' + this.rowData.dialogId + ':' + this.rowData.sequenceId + '.lineParticipantState', callback : this.chatLineStateUpdate, context:this});
        }
        else if (this.rowData && this.rowData.failed && this.rowData.type === "richContent") {
            updateLineState.call(this, STRUCTURE_CONTENT_FAILED_STATUS);
        }
    };

    ChatLineStateViewController.prototype.chatLineStateUpdate = function(data){
       // THIS is a Temp Fix, need to fix the bindings.
       if(this && this.disposed) {return;}

        if(!data.newValue){
            return;
        }
        var chatLineState = data.newValue[this.consumerId] || lpTag.AMSStatics.messageState.SENT;
        if (chatLineState) {
            if(isLastStatusOfMessage(chatLineState, this.rowData)){
                this.unbindModel({
                    modelPath: 'chats.' + this.convId + '.chatInfo.linesState.' + this.rowData.dialogId + ':'  + this.rowData.sequenceId + '.lineParticipantState',
                    callback: this.chatLineStateUpdate,
                    context: this
                });
            }
        }

        updateLineState.call(this, chatLineState);
    };

    function updateLineState(chatLineState) {
        var tooltipText, iconElement;
        iconElement = this.getFirstElement(this.LPViewMap.lpview_state_icon, this.currentView);

        if (iconElement && chatLineState && this.LPClassesMap[chatLineState]) {
            // reset the old classname
            iconElement.className = this.LPClassesMap.state_icon;
            this.addClass(iconElement, this.LPClassesMap.line_state_icon);
            // add the state classname
            this.addClass(iconElement, this.LPClassesMap[chatLineState]);

            tooltipText = this.chatLineStateTextMap[chatLineState] || "";
            if (lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.convId, this.rowData.dialogId, this.chatsRootModelPath)) {
                // todo - send a collection of participants data instead of the tooltip text
                iconElement.setAttribute("title", ""); // preventing the parent (chat line) title from appearing
                bindStateIconBubble.call(this, iconElement, tooltipText);
            } else {
                iconElement.setAttribute("title", tooltipText);
            }
        }
        this.addClass(this.currentView, 'line_state');
    }

    function isLastStatusOfMessage(chatLineState, rowData) {
        return (rowData.subType !== lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM &&
            (chatLineState === lpTag.AMSStatics.messageState.READ || chatLineState === lpTag.AMSStatics.messageState.NACK)) ||
            (rowData.subType === lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM && chatLineState === lpTag.AMSStatics.messageState.ERROR);
    }

    function bindStateIconBubble(iconElement, tooltipText) {
        this.bindViewEvent({
            view: iconElement,
            DOMEvent: "mouseenter",
            callback: showBubble,
            context: this,
            lpEventData: {
                iconElement: iconElement,
                tooltipText: tooltipText
            }
        });
        this.bindViewEvent({
            view: iconElement,
            DOMEvent: "mouseleave",
            callback: hideBubble,
            context: this
        });
    }

    function showBubble(e) {
        var eventData;
        if (!this.bubbleComponent) {
            eventData = e.lpEventData || {};
            createAndRenderBubble.call(this, eventData);
        }
    }

    function hideBubble() {
        if (this.bubbleComponent) {
            this.bubbleComponent.close(true);
            delete this.bubbleComponent;
        }
    }

    function createAndRenderBubble(eventData) {
        this.bubbleComponent = new Bubble({
            containerSelector: '.web-agent-wrapper',
            targetControl: eventData.iconElement,
            contentView: new ChatLineStateBubbleView({
                text: eventData.tooltipText
            }),
            position: Bubble.POSITION.BOTTOM,
            isDelayed: true
        });
        this.bubbleComponent.render();
    }

    window.ChatLineStateViewController = ChatLineStateViewController;

    return ChatLineStateViewController;

});
